__turbopack_context__.v({
  "className": "roboto_condensed_b98f4035-module__jQmMfq__className",
  "variable": "roboto_condensed_b98f4035-module__jQmMfq__variable",
});
